export const products = {
  fields: {
    code: 'Mã',
    maVach: 'Mã vạch',
    maQR: 'Mã QR',
    name: 'Tên hàng',
    donViCoBan: 'ĐVT cơ bản',
    customsNameEn: 'Tên khai báo hải quan (TA)',
    customsNameVi: 'Tên khai báo hải quan (TV)',
    tenKhaiBaoVi: 'Tên khai báo VI',
    tenKhaiBaoEn: 'Tên khai báo EN',
    description: 'Mô tả',
    status: 'Trạng thái kinh doanh',
    actions: 'Thao tác',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    declarationType: 'Loại công bố',
    productCategory: 'Nhóm sản phẩm',
    priceGroup: 'Nhóm giá',
    declarationGroup: 'Nhóm công bố',
    registeredCompany: 'Công ty đăng ký',
    exporterCompany: 'Đối tác xuất khẩu',
    importerCompany: 'Công ty nhập khẩu',
    conditionalItem: 'Hàng điều kiện',
    certificate: 'Giấy chứng nhận',
    sampleTestRequired: 'Yêu cầu test mẫu',
    declarationStartDate: 'Ngày bắt đầu công bố',
    declarationEndDate: 'Ngày kết thúc công bố',
    declarationFee: 'Tiền công bố',
    qualityFee: 'Tiền KTCL',
    unitCost: 'Đơn vị tính giá vốn nội bộ',
    declarationUnit: 'Đơn vị khai báo',
    fixedConditionName: 'Tên điều kiện fix',
    isSensitive: 'Hàng nhạy cảm',
    businessNote: 'Ghi chú mảng',
    note: 'Ghi chú',
    parentId: 'ID nhóm cha',
    parentGroup: 'Nhóm cha',
    onOffAction: 'Kinh doanh',
    nhomHang: 'Nhóm hàng',
    giaBan: 'Giá bán',
    giaVon: 'Giá vốn',
    tonKho: 'Tồn kho',
    khachDat: 'Khách đặt',
    thumbnail: 'Ảnh',
    loaiHang: 'Loại hàng',
    yeuThich: 'Yêu thích',
    banTrucTiep: 'Bán trực tiếp',
    baoHanh: 'Bảo hành',
    moTa: 'Mô tả',
    thuongHieuId: 'Thương hiệu',
    nhaCungCapId: 'Nhà cung cấp',
    viTriId: 'Vị trí sản phẩm',
    viTriSanPham: 'Vị trí sản phẩm',
    dinhMucTonThapNhat: 'Định mức tồn thấp nhất',
    dinhMucTonCaoNhat: 'Định mức tồn cao nhất',
    trongLuong: 'Trọng lượng thùng',
    giaTriTonKho: 'Giá trị tồn kho',
    quyCachThung: 'Quy cách thùng',
    theTichThung: 'Thể tích thùng',
    tongTrongLuongTon: 'Tổng trọng lượng tồn (kg)',
    tongTheTichTon: 'Tổng thể tích tồn',
    chieuDai: 'Dài (cm)',
    chieuRong: 'Rộng (cm)',
    chieuCao: 'Cao (cm)',
    canNangKien: 'Cân nặng kiện',
    quyCachKien: 'Quy cách kiện',
    donViTrongLuong: 'Đơn vị trọng lượng',
    thoiGianBaoHanh: 'Thời gian bảo hành (tháng)',
    loaiBaoHanh: 'Loại bảo hành',
    phamVi: 'Phạm vi áp dụng',
    danhSachChiNhanhIds: 'Chi nhánh áp dụng',
    hinhAnh: 'Hình ảnh',
    danhSachThanhPhan: 'Thành phần combo',
    tenDonViCoBan: 'Tên đơn vị cơ bản',
    thuocTinhs: 'Thuộc tính',
  },
  donViTrongLuong: {
    g: 'Gam (g)',
    kg: 'Kilogram (kg)',
    mg: 'Miligram (mg)',
  },
  loaiBaoHanh: {
    baoHanh: 'Bảo hành',
    baoTri: 'Bảo trì',
    caHai: 'Bảo hành & bảo trì',
  },
  phamVi: {
    toanDuAn: 'Toàn dự án',
    theoChiNhanh: 'Theo chi nhánh',
    chonTatCaMang: 'Chọn tất cả',
    boChonTatCaMang: 'Bỏ chọn',
    emptyBranches: 'Không có chi nhánh nào để chọn',
  },
  trangThai: {
    dangKinhDoanh: 'Đang kinh doanh',
    ngungKinhDoanh: 'Ngừng kinh doanh',
    /** Nút hành động khi SP đang ngừng KD — mở lại kinh doanh. */
    moKinhDoanh: 'Mở kinh doanh',
  },
  loaiHang: {
    hangHoa: 'Hàng hóa',
    combo: 'Combo',
  },
  combo: {
    addRow: 'Thêm hàng thành phần',
    soLuong: 'Số lượng',
    placeholder: 'Chọn hàng thành phần',
    noOptions: 'Không tìm thấy hàng hóa',
    giaVonAutoHint: 'Tự tính từ thành phần combo',
    loading: 'Đang tải…',
    hint: 'Chọn các hàng hóa cấu thành combo và số lượng tương ứng.',
    empty: 'Chưa có hàng thành phần',
    remove: 'Xóa',
    columnStt: 'STT',
    columnMaHang: 'Mã hàng',
    columnTenHang: 'Tên hàng thành phần',
    columnGiaVon: 'Giá vốn',
    columnTongGiaVon: 'Tổng giá vốn',
    columnGiaBan: 'Giá bán',
    columnTongGiaBan: 'Tổng giá bán',
  },
  /** Card "Quản lý theo đơn vị tính và thuộc tính". */
  donViTinhVaThuocTinh: {
    title: 'Đơn vị tính · thuộc tính',
    donViTinhSubtitle: 'Đơn vị tính',
    donViTinhDescription:
      'Thêm đơn vị bán hoặc nhập như chai, lốc, thùng. Đặt công thức quy đổi để tính nhanh giá và tồn kho. Ví dụ: 1 lốc = 4 chai, 1 thùng = 20 lốc.',
    thuocTinhSubtitle: 'Thuộc tính',
    thuocTinhDescription: 'Thêm đặc điểm như hương vị, dung tích, màu sắc',
    themThuocTinh: 'Thêm thuộc tính',
    tenThuocTinhPlaceholder: 'Tên thuộc tính (vd: Hương vị)',
    giaTriThuocTinhPlaceholder: 'Giá trị (vd: Vani)',
    chonThuocTinhPlaceholder: '— Chọn thuộc tính —',
    chonGiaTriPlaceholder: '— Chọn giá trị —',
    nhapGiaTriPlaceholder: 'Nhập giá trị',
    coBanLabel: 'Đơn vị tính',
    donViCoBanLabel: 'Đơn vị cơ bản',
    placeholderTenDonViCoBan: '— Chọn đơn vị tính —',
    donViCoBanRequired: 'Vui lòng chọn đơn vị tính',
    tyLeQuyDoiKhongHopLe: 'Tỷ lệ quy đổi của đơn vị «{ten}» phải lớn hơn 0',
    donViCoBanAutoResetToast: 'Đã tự xoá các đơn vị quy đổi khi đổi đơn vị cơ bản',
    themDonVi: 'Thêm đơn vị quy đổi',
    emptyDonVi: 'Chưa có đơn vị quy đổi. Nhấn nút "Thêm đơn vị" để thêm.',
    duplicateName: 'Tên đơn vị đã tồn tại trong danh sách',
    labelTenDonViQuyDoi: 'Đơn vị quy đổi',
    labelGiaTriQuyDoi: 'Tỷ lệ',
    labelSlDonViCoBan: 'SL đơn vị cơ bản',
    labelSlDonViQuyDoi: 'SL đơn vị quy đổi',
    placeholderTenDonViQuyDoi: 'vd: thùng',
    giaBanPlaceholder: '0',
    labelGiaBanQuyDoi: 'Giá bán (SKU phụ)',
    invalidTyLe: 'SL đơn vị cơ bản / quy đổi phải là số > 0 (cho phép số lẻ, vd. 45,7)',
    hangCungLoaiSubtitle: 'Hàng cùng loại (SKU theo ĐVT)',
    hangCungLoaiDescription:
      'Mỗi đơn vị quy đổi tự động tạo một hàng hóa riêng, chia sẻ tồn kho với hàng gốc theo tỷ lệ quy đổi.',
    colDonVi: 'Đơn vị',
    colQuyDoi: 'Quy đổi',
    colMaHang: 'Mã hàng',
    thietLapGia: 'Giá theo bảng giá',
    maHangPreview: '(Tự sinh)',
  },
  /** Card "Vị trí, trọng lượng". */
  viTriTrongLuong: {
    title: 'Vị trí · kích thước · trọng lượng',
    description: 'Vị trí kho, kích thước và trọng lượng / quy cách thùng',
  },
  /** Card "Tồn kho". */
  tonKhoSection: {
    title: 'Tồn kho',
    description:
      'Quản lý số lượng tồn kho và định mức tồn. Khi tồn kho chạm đến định mức, bạn sẽ nhận được cảnh báo từ KiotViet.',
    quanLySerialIMEI: 'Quản lý theo serial/IMEI',
    quanLyTheoHanSuDung: 'Quản lý theo hạn sử dụng',
  },
  /** Card gộp tồn kho + vị trí. */
  tonKhoVaViTri: {
    title: 'Tồn kho · vị trí',
  },
  /** Bảng "Tồn kho theo lô". */
  loHang: {
    colMaLo: 'Số lô',
    colHanSuDung: 'Hạn sử dụng',
    colSoLuong: 'Số lượng',
    colGiaVon: 'Giá vốn',
    colTrangThai: 'Trạng thái',
    trangThai: {
      khongRo: 'Không rõ',
      conHan: 'Còn hạn',
      canHan: 'Cận hạn (<7 ngày)',
      hetHan: 'Hết hạn',
    },
    notEnabled: 'Hàng hóa này không bật quản lý theo hạn sử dụng.',
    empty: 'Chưa có lô nào.',
    unit: 'lô',
  },
  /** Card "Giá vốn, giá bán". */
  giaBanSection: {
    title: 'Giá vốn · giá bán mặc định',
    thietLapGia: 'Giá theo bảng giá',
    giaBanPlaceholder: '0',
    giaVonPlaceholder: '0',
    setupDialogTitle: 'Giá theo bảng giá',
    setupDialogSubtitle: '{count} bảng giá đang áp dụng',
    setupDialogHint:
      'Bấm ô Giá bán để nhập giá riêng cho từng bảng. Xong → Lưu hàng hóa để áp dụng. Không nhập = dùng giá bán mặc định trên form.',
    setupDialogHintAdd:
      'Khi tạo mới, giá các bảng có công thức được tính sẵn từ giá vốn / giá bán trên form. Có thể sửa tay hoặc bấm Áp dụng công thức để tính lại. Xong → Lưu hàng hóa để áp dụng.',
    setupDialogHintMatrix:
      'Cột đầu là mã hàng; các cột sau là đơn vị cơ bản và đơn vị quy đổi. Mỗi hàng một bảng giá — nhập giá cho từng đơn vị. Có công thức thì được tính sẵn; có thể sửa tay hoặc Áp dụng công thức. Xong → Lưu hàng hóa để áp dụng.',
    setupDialogPlaceholder: 'Nhập giá',
    setupDialogColBangGia: 'Tên bảng giá',
    setupDialogColGiaBan: 'Giá bán',
    setupDialogEmpty: 'Chưa có bảng giá nào đang áp dụng. Tạo bảng giá ở menu Bảng giá trước.',
    setupDialogSkip: 'Bỏ qua',
    setupDialogDone: 'Xong',
    setupDialogSaveSuccess: 'Đã áp dụng giá cho các bảng giá đã chọn.',
    setupDialogSavePartial: 'Một số bảng giá cập nhật thất bại',
    setupDialogApDungCongThuc: 'Áp dụng công thức',
    setupDialogApDungTooltip:
      'Tính lại cột đơn vị cơ bản theo công thức từng bảng giá, rồi nhân tỷ lệ quy đổi ĐVT cho các cột còn lại.',
    setupDialogApDungSuccess: 'Đã điền giá gợi ý cho {applied}/{total} ô theo công thức / tỷ lệ quy đổi.',
    setupDialogApDungEmpty: 'Không có bảng giá nào có công thức để áp dụng.',
    setupDialogApDungNoChange:
      'Không tính được giá (thiếu giá vốn / giá bảng nguồn / giá cột cơ bản để nhân tỷ lệ). Kiểm tra form.',
    setupDialogBadgeChuaCoGia: 'Chưa có giá',
    setupDialogBadgeSeXoa: 'Sẽ bị xóa',
    setupDialogHintSeXoa:
      'Bảng giá này không còn áp dụng (đã xóa / ngừng). Giá của SP trên bảng sẽ bị gỡ khi bạn bấm Xong và Lưu hàng hóa. Không thể sửa.',
    setupDialogBangGiaDaXoa: 'Bảng giá đã xóa',
    setupDialogBangGiaBiXoaWarning:
      'Bảng giá đã bị xóa: {names}. Sẽ gỡ giá khỏi SP khi bạn bấm Xong và Lưu hàng hóa. Không thể sửa các dòng này.',
    setupDialogWarningTyLeQuyDoi:
      'Nếu vừa sửa tỷ lệ quy đổi ĐVT bên dưới form, hãy bấm «Áp dụng công thức» để cập nhật lại giá các cột quy đổi cho đúng (giá cơ bản × tỷ lệ).',
    setupDialogApDungHangTooltip: 'Áp dụng công thức cho bảng giá này (cả các ĐVT quy đổi).',
    setupDialogApDungCotTooltip: 'Áp dụng công thức / tỷ lệ quy đổi cho cột đơn vị này.',
    tyLeChangedBangGiaWarning:
      'Cần cập nhật lại bảng giá cho đúng. Mở «Giá theo bảng giá» và bấm «Áp dụng công thức».',
  },
  /** Popup "Thiết lập giá cho hàng cùng loại" (ma trận đơn vị × bảng giá). */
  hangCungLoaiGia: {
    dialogTitle: 'Thiết lập giá cho hàng cùng loại',
    dialogSubtitle: 'Có {count} đơn vị cần thiết lập giá theo bảng giá',
    chooseBangGia: 'Bảng giá áp dụng',
    colDonVi: 'Đơn vị',
    colGiaVon: 'Giá vốn',
    colGiaBanChung: 'Giá bán chung',
    emptyRows: 'Chưa có đơn vị quy đổi nào. Hãy thêm đơn vị ở mục trên trước.',
    emptyBangGia: 'Chưa có bảng giá nào đang áp dụng.',
    skip: 'Bỏ qua',
    done: 'Xong',
    hint:
      'Mỗi đơn vị có danh sách bảng giá theo hàng. Giá có công thức được tính sẵn từ giá vốn / giá bán chung. Sửa trực tiếp ô nhập, hoặc bấm Áp dụng công thức để tính lại.',
    apDungCongThuc: 'Áp dụng công thức',
    apDungTooltip:
      'Điền nhanh theo công thức từng bảng giá cho mọi đơn vị. Chỉ bảng đã cấu hình công thức mới đổi.',
    saveSuccess: 'Đã áp dụng giá cho hàng cùng loại.',
    savePartial: 'Một số giá của hàng cùng loại cập nhật thất bại',
  },
  tonKho: {
    tatCa: 'Tất cả',
    conHang: 'Còn hàng',
    hetHang: 'Hết hàng',
  },
  status: {
    all: 'Tất cả',
    active: 'Đang hoạt động',
    inactive: 'Ngừng hoạt động',
  },
  common: {
    yes: 'Có',
    no: 'Không',
  },
  sampleTests: {
    Co: 'Có',
    Khong: 'Không',
    TuyTruongHop: 'Tùy trường hợp',
  },
  filters: {
    all: 'Tất cả',
    productGroupSection: 'Nhóm hàng',
    treeAll: 'Tất cả',
    treeSearch: 'Tìm kiếm nhóm hàng',
    productGroupHint: 'Chọn nhóm để lọc (gồm cả nhóm con). Quản lý cây nhóm tại màn nhóm hàng.',
    openProductCategories: 'Mở danh mục nhóm',
    openNhomHang: 'Mở quản lý nhóm hàng',
    loaiHang: 'Loại hàng',
    attributesSection: 'Thuộc tính',
    loaiHangThuong: 'Hàng hóa thường',
    loaiHangSanXuat: 'Hàng hóa - sản xuất',
    loaiHangDichVu: 'Dịch vụ',
    loaiHangCombo: 'Combo - Đóng gói',
    productTypeSection: 'Loại hàng',
    /** Một thẻ gộp «Sắp xếp theo» + «Thứ tự» — giống nhóm Kiot. */
    sortSection: 'Sắp xếp',
    sortBy: 'Sắp xếp theo',
    sortDirection: 'Thứ tự',
    sortOrder: 'Sắp xếp',
    maHangHoa: 'Mã hàng',
    tenHangHoa: 'Tên hàng',
    maNhomHang: 'Mã nhóm hàng',
    tenNhomHang: 'Tên nhóm hàng',
    ngayTaoTu: 'Ngày tạo từ',
    ngayTaoDen: 'Ngày tạo đến',
    asc: 'Tăng dần',
    desc: 'Giảm dần',
    choiceTitle: 'Lọc theo lựa chọn',
    textDetailTitle: 'Tìm theo nhiều trường',
    /** Popover ô tìm thanh công cụ — xóa hết query lọc (giữ pageSize nếu có). */
    clearToolbar: 'Xóa lọc',
    notSelected: '— Chọn —',
    sortDefault: 'Mặc định',
    maVach: 'Mã vạch',
  },
  declarationTypes: {
    CO: 'C/O',
    Phyto: 'Kiểm dịch thực vật (Phyto)',
    Fumigation: 'Hun trùng (Fumigation)',
    Khac: 'Khác',
  },
  messages: {
    khongDuocAm: 'Giá trị không được âm',
    trungTenConfirmTitle: 'Trùng tên hàng hóa',
    trungTenConfirmMessage: 'Đã có hàng hóa «{ten}» (mã {ma}). Bạn vẫn muốn lưu với tên này?',
    soAmConfirmTitle: 'Xác nhận số âm',
    soAmConfirmMessage: 'Các ô sau đang nhập số âm: {fields}. Bạn có chắc chắn muốn lưu?',
    listSummary: 'Tổng số {count} hàng theo bộ lọc',
    noData: 'Chưa có dữ liệu',
    scaffoldHint: 'Đây là khung module sản phẩm. Bạn có thể nối API, filter, popup thêm/sửa và phân quyền chi tiết ở bước tiếp theo.',
    saving: 'Đang lưu...',
    importDescription: 'Tải file mẫu, điền dữ liệu và chọn file để import. Hệ thống xử lý trên server.',
    importSuccess: 'Import dữ liệu thành công',
    importFailed: 'Import dữ liệu thất bại',
    bulkDeleteSuccess: 'Đã xóa các hàng hóa đã chọn.',
    bulkNgungSuccess: 'Đã ngừng kinh doanh các hàng hóa đã chọn.',
    bulkNgungPartial: 'Đã ngừng {ok}/{total} hàng; {fail} hàng lỗi.',
    exportSuccess: 'Xuất dữ liệu thành công',
    exportFailed: 'Xuất dữ liệu thất bại',
    uploadingImage: 'Đang tải ảnh…',
    pasteImageHint: 'Ctrl+V trong khung hoặc bấm Paste ảnh',
    pasteImageNoImage: 'Clipboard không có ảnh. Hãy copy ảnh hoặc dán link http(s).',
    imageHint: 'Mỗi ảnh không quá 2 MB',
    noThuongHieuOptions: 'Không có thương hiệu',
    noDonViTinhOptions: 'Không có đơn vị tính',
    galleryHint: 'Upload nhiều ảnh. Ảnh đầu (đánh số 1) là ảnh đại diện.',
    setAsMainImage: 'Đặt làm ảnh đại diện',
    mainImage: 'Ảnh đại diện',
    dragDropImageHint: 'Kéo thả ảnh vào đây hoặc nhấp để chọn',
    maxImageSizeHint: 'Giới hạn: 20 MB mỗi file',
    noHistory: 'Chưa có giao dịch nào',
    historyComingSoon: 'Tính năng lịch sử giao dịch sẽ được bổ sung (phiếu nhập, hóa đơn, đơn hàng).',
    barcodePrintHint: 'Sử dụng nút bên dưới để chọn định dạng mã vạch và in tem.',
    comingSoon: 'Tính năng đang phát triển',
    branchRequired: 'Vui lòng chọn chi nhánh khi phạm vi là "Theo chi nhánh"',
  },
  export: {
    titles: {
      selectColumns: 'Chọn cột hiển thị',
    },
    hints: {
      selectAtLeastOne: 'Chọn ít nhất 1 cột để xuất file',
      required: 'Bắt buộc',
      theoChiNhanh:
        'Tồn kho, giá vốn, KH đặt và Đặt NCC xuất thành từng dòng theo chi nhánh, không cộng tổng toàn hệ thống.',
    },
    actions: {
      selectAll: 'Chọn tất cả',
      deselectAll: 'Bỏ chọn tất cả',
      xuatTheoMauNhap: 'Xuất theo mẫu nhập',
      resetAll: 'Chọn lại tất cả',
    },
    messages: {
      selectedCount: 'Đã chọn {selected}/{total} cột',
      noColumnSelected: 'Vui lòng chọn ít nhất 1 cột',
    },
    groups: {
      hangHoa: 'Hàng hóa',
      giaBanTonKho: 'Giá bán & Tồn kho',
      donViTinh: 'Đơn vị tính',
      thuocTinh: 'Thuộc tính',
      serialImei: 'Serial/IMEI',
      thongTinKhac: 'Thông tin khác',
    },
    columns: {
      datNcc: 'Đặt NCC',
      duKienHetHang: 'Dự kiến hết hàng',
      donViQuyDoi: 'Quy đổi',
      maDonViCoBan: 'Mã DVT cơ bản',
      maHangLienQuan: 'Mã HH liên quan',
      suDungImei: 'Sử dụng IMEI',
      serialImei: 'Serial/IMEI',
      baoTriDinhKy: 'Bảo trì định kỳ',
    },
  },
  titles: {
    addQuick: 'Thêm nhanh',
    /** Nút chính giống Kiot «Thêm mới». */
    addNew: 'Thêm mới',
    /** Nhãn nút giữ nguyên «Import» như KiotViet (tiếng Việt). */
    importKiot: 'Import',
    exportFile: 'Xuất file',
    /** Title modal "Tạo hàng hóa" — đồng bộ với mockup KiotViet. */
    createModal: 'Tạo hàng hóa',
  },
  import: {
    xuLyTrungMaKhacTen: 'Trùng mã khác tên',
    xuLyTrungBaoLoi: 'Báo lỗi và bỏ qua',
    xuLyTrungThayThe: 'Thay thế bản ghi cũ',
    capNhatTonKho: 'Cập nhật tồn kho từ file',
    capNhatGiaVon: 'Cập nhật giá vốn từ file',
    capNhatMoTa: 'Cập nhật mô tả từ file',
  },
  actions: {
    deleteSelected: 'Xóa đã chọn ({count})',
    deleteSelectedMenu: 'Xóa đã chọn',
    ngungKinhDoanhSelected: 'Ngừng kinh doanh ({count})',
    createHoaDonSelected: 'Tạo hóa đơn ({count})',
    createDatHangSelected: 'Tạo đặt hàng ({count})',
    createDatHangMenu: 'Tạo đặt hàng',
    createPhieuNhapSelected: 'Tạo phiếu nhập ({count})',
    createPhieuNhapMenu: 'Tạo phiếu nhập kho',
    createPhieuXuatSelected: 'Tạo phiếu xuất ({count})',
    createPhieuXuatMenu: 'Tạo phiếu xuất kho',
    createXuatHuySelected: 'Tạo xuất hủy ({count})',
    createXuatHuyMenu: 'Tạo xuất hủy',
    createKiemKeSelected: 'Tạo kiểm kê ({count})',
    createKiemKeMenu: 'Tạo kiểm kê',
    createChuyenHangSelected: 'Tạo chuyển hàng ({count})',
    createChuyenHangMenu: 'Tạo chuyển hàng',
    chooseImage: 'Chọn ảnh',
    pasteImage: 'Dán ảnh',
    printBarcode: 'In mã vạch',
    printBarcodeTitle: 'In mã vạch — {name}',
    saveAndCreate: 'Lưu & Tạo thêm hàng',
    saveAndCopy: 'Lưu & Sao chép',
    skip: 'Bỏ qua',
    createNew: 'Tạo mới',
    /** Nút "+ Tạo mới" ở header section "Nhóm hàng" (sidebar Hàng hóa). */
    quickCreateGroup: 'Tạo mới',
    /** Nút "Chọn tất cả" footer section "Nhóm hàng". */
    selectAllGroups: 'Chọn tất cả',
    /** Nút "Bỏ chọn tất cả" footer section "Nhóm hàng" (khi đang có nhóm đã chọn). */
    deselectAllGroups: 'Bỏ chọn tất cả',
    /** Nút "Áp dụng" footer section "Nhóm hàng". */
    applyGroups: 'Áp dụng',
  },
  /** Modal footer (Bán trực tiếp + tooltip). */
  formFooter: {
    banTrucTiepTooltip:
      'Khi bật, hàng hóa có thể bán trực tiếp trên POS. Nếu tắt, chỉ bán được qua đơn hàng.',
  },
  /** Tabs dùng cho popup Thêm/Sửa hàng hóa (`ProductPopup` / `ProductForm`). */
  detailTabs: {
    generalInfo: 'Thông tin chung',
    gallery: 'Hình ảnh',
    barcode: 'Mã vạch',
    history: 'Lịch sử giao dịch',
  },
  /** Tabs dùng cho expand-row của grid danh sách (`ProductListInlineDetail`). */
  inlineDetailTabs: {
    info: 'Thông tin',
    description: 'Mô tả, ghi chú',
    stockCard: 'Thẻ kho',
    pendingStockCard: 'Thẻ kho chờ xử lý',
    inventory: 'Tồn kho',
    thongTinVat: 'Thông tin xuất VAT',
    salesChannels: 'Liên kết kênh bán',
  },
  /** Dialog xác nhận xóa hàng hóa (dùng cho cột thao tác + bulk + expand). */
  deleteDialog: {
    title: 'Xóa hàng hóa',
    bodyNoCode: 'Hệ thống sẽ xóa hoàn toàn hàng hóa này trên toàn bộ chi nhánh nhưng vẫn giữ thông tin hàng hóa trong các giao dịch lịch sử nếu có. Bạn có chắc chắn muốn xóa?',
    bodyIntro: 'Hệ thống sẽ xóa',
    bodyOutro: 'trên toàn bộ chi nhánh nhưng vẫn giữ thông tin hàng hóa trong các giao dịch lịch sử nếu có.',
    bodyAndMore: '... và {count} mã khác',
    bodyConfirm: 'Bạn có chắc chắn muốn xóa?',
  },
  bulkNgungDialog: {
    title: 'Ngừng kinh doanh',
    body: 'Ngừng kinh doanh {count} hàng hóa đã chọn trên toàn hệ thống? Hàng vẫn giữ lịch sử giao dịch nhưng không bán được cho đến khi mở lại.',
  },
  /** Nội dung tab "Mô tả, ghi chú" — 2 card (Mô tả / Ghi chú đặt hàng). */
  descriptionTab: {
    descriptionLabel: 'Mô tả',
    orderNoteLabel: 'Ghi chú đặt hàng',
    emptyDescription: 'Chưa có mô tả',
    emptyOrderNote: 'Chưa có ghi chú',
  },
  /** Nội dung tab Tồn kho trong expand-row — bảng con theo chi nhánh. */
  inventoryTab: {
    searchPlaceholder: 'Tìm tên chi nhánh',
    totalLabel: 'Tổng',
    empty: 'Chưa có chi nhánh nào có hàng này',
    emptyHint: 'Hàng hóa chưa được phân bổ về chi nhánh nào.',
    comingSoonHint: 'Tính năng đang phát triển',
    cols: {
      chiNhanh: 'Chi nhánh',
      tonKho: 'Tồn kho',
      datNcc: 'Đặt NCC',
      khachDat: 'KH đặt',
      duKienHetHang: 'Dự kiến hết hàng',
      topSale: 'Top sale',
      nonmoving: 'Nonmoving',
      giaTriTonKho: 'Giá trị tồn kho',
      quyCachThung: 'Quy cách thùng',
      theTichThung: 'Thể tích thùng',
      trongLuong: 'Trọng lượng thùng',
      tongTrongLuongTon: 'Tổng trọng lượng tồn (kg)',
      tongTheTichTon: 'Tổng thể tích tồn',
      viTriSanPham: 'Vị trí sản phẩm',
      trangThai: 'Trạng thái',
    },
    notAvailable: '---',
  },
  /** Tab Thẻ kho — sổ nhập/xuất (kể cả phiếu tạm) của CN đang đứng. */
  stockCardTab: {
    empty: 'Chưa có giao dịch kho đã hoàn thành tại chi nhánh này',
    emptyPending: 'Không có phiếu tạm / chờ nào chưa ảnh hưởng tồn kho tại chi nhánh này',
    emptyFiltered: 'Không có giao dịch phù hợp với bộ lọc',
    filters: {
      searchPlaceholder: 'Tìm theo mã phiếu, mã chứng từ',
      dateRange: 'Ngày chứng từ',
      from: 'Từ ngày',
      to: 'Đến ngày',
      allLoaiPhieu: 'Tất cả loại phiếu',
      allNhap: 'Tất cả phiếu nhập',
      allXuat: 'Tất cả phiếu xuất',
      khachHang: 'Mã, tên khách hàng',
    },
    actions: {
      exportExcel: 'Xuất Excel (có kiểm tra CT)',
      helpCalc: 'Cách tính',
    },
    helpModal: {
      title: 'Cách tính tồn kho & giá vốn (thẻ kho)',
      close: 'Đóng',
      intro:
        'Thẻ kho replay toàn bộ phiếu đã hoàn thành tại chi nhánh đang đứng, theo ngày chứng từ (cũ → mới). Mục đích chính: gắn giá vốn đúng cho từng lần xuất để tính lãi/lỗ.',
      tonTitle: '1. Tồn cuối',
      tonBody: 'Mỗi dòng cộng dồn số lượng có dấu:',
      tonLi1: 'Nhập: + số lượng',
      tonLi2: 'Xuất: − số lượng',
      tonLi3: 'Kiểm kê: dùng đúng dấu trên phiếu (+ dư / − thiếu)',
      tonFormula: 'Tồn cuối dòng = Tồn trước + SL ký\nSL ký = Nhập − Xuất (KK theo dấu phiếu)',
      gvNhapTitle: '2. Giá vốn trên dòng nhập',
      gvNhapBody:
        'Cột Giá vốn dòng nhập = bình quân gia quyền (BQGQ) sau lần nhập — không phải đơn giá phiếu (trừ khi tồn trước ≤ 0 / đang âm).',
      gvNhapLi1: 'Tồn trước > 0: pha BQGQ chuẩn với avg cũ',
      gvNhapLi2: 'Tồn trước = 0 hoặc chưa có avg: Giá vốn = giá nhập (đơn giá − giảm giá)',
      gvNhapLi3: 'Tồn trước < 0 (đang âm): Giá vốn = giá nhập (không chia / tồn sau)',
      gvNhapFormula:
        'Tồn > 0:\n  BQGQ = (tồn × avg cũ + SL × giá nhập) / (tồn + SL)  → ROUND 2 chữ số\nTồn ≤ 0 hoặc đang âm:\n  BQGQ = giá nhập',
      gvXuatTitle: '3. Giá vốn trên dòng xuất',
      gvXuatBody: 'Dùng để tính lãi/lỗ khi xuất:',
      gvXuatLi1: 'Còn tồn (tồn trước > 0): Giá vốn = avg trước xuất; avg không đổi',
      gvXuatLi2: 'Xuất âm (tồn trước ≤ 0): Giá vốn = BQGQ gần nhất (lastAvg)',
      gvXuatLi3: 'Chưa từng có lần nhập tạo avg → Giá vốn = 0',
      giaTriTitle: '4. Giá trị tồn cuối',
      giaTriBody: 'Giá trị tồn trên từng dòng thẻ kho:',
      giaTriFormula: 'Giá trị tồn cuối = Tồn cuối × Giá vốn (dòng)',
      noteTitle: 'Lưu ý',
      noteLi1: 'Thứ tự tính theo Ngày chứng từ (cũ → mới), không theo ngày tạo trên hệ thống.',
      noteLi2: 'Hủy phiếu nhập vẫn cho tồn âm nếu sau đó đã xuất hết lượng nhập đó.',
      noteLi3: 'Xuất Excel có sheet «Kiem tra CT» với công thức đối chiếu ĐÚNG/SAI.',
    },
    summary: {
      tonDauKy: 'Tồn đầu kỳ',
      tongNhap: 'Tổng nhập',
      tongXuat: 'Tổng xuất',
      tonCuoiKy: 'Tồn cuối kỳ',
      tonHienTai: 'Tồn hiện tại',
      tongNhapCho: 'Nhập chờ',
      tongXuatCho: 'Xuất chờ',
      tonDuKien: 'Tồn dự kiến',
    },
    cols: {
      ngayChungTu: 'Ngày chứng từ',
      ngayTao: 'Ngày tạo',
      maPhieu: 'Mã phiếu',
      loaiPhieu: 'Loại phiếu',
      maChungTu: 'Mã chứng từ liên quan',
      doiTac: 'Đối tác',
      nhapXuat: 'Nhập/Xuất',
      donGia: 'Giá giao dịch',
      giaVon: 'Giá vốn',
      tonCuoi: 'Tồn cuối',
      giaTriTonCuoi: 'Giá trị tồn cuối',
      trangThai: 'Trạng thái',
      ghiChu: 'Ghi chú',
    },
    loaiChungTu: {
      hoaDon: 'Hóa đơn',
      traHang: 'Trả hàng',
      chuyenHang: 'Chuyển hàng',
      nhanHang: 'Nhận hàng',
      datHangNCC: 'Đặt hàng NCC',
      kiemKe: 'Kiểm kho',
    },
    trangThaiPhieu: {
      phieuTam: 'Phiếu tạm',
      cho: 'Chờ duyệt',
      daHoanThanh: 'Đã hoàn thành',
    },
    loaiPhieu: {
      NHAP_MUA: 'Nhập mua',
      NHAP_CHUYEN: 'Nhập chuyển',
      NHAP_TRA_HANG: 'Nhập trả hàng',
      NHAP_DIEU_CHINH: 'Nhập điều chỉnh',
      NHAP_KHAC: 'Nhập khác',
      XUAT_BAN: 'Xuất bán',
      XUAT_CHUYEN: 'Xuất chuyển',
      XUAT_TRA_NCC: 'Xuất trả NCC',
      XUAT_HUY: 'Xuất hủy',
      XUAT_NOI_BO: 'Xuất nội bộ',
      XUAT_DIEU_CHINH: 'Xuất điều chỉnh',
      XUAT_KHAC: 'Xuất khác',
      KIEM_KE: 'Kiểm kê',
    },
  },
  formTabs: {
    info: 'Thông tin',
    description: 'Mô tả',
    warranty: 'Bảo hành, bảo trì',
    branchBusiness: 'Chi nhánh kinh doanh',
    global: 'Toàn hệ thống',
  },
  formColumns: {
    thongTin: 'Thông tin',
    lienKet: 'Liên kết',
  },
  detailFields: {
    stockLimit: 'Định mức tồn',
  },
  detailActions: {
    copy: 'Sao chép',
    addUnit: 'Thêm đơn vị tính',
    addAttribute: 'Thêm thuộc tính',
    viewDetail: 'Chi tiết',
    detailTitle: 'Chi tiết hàng hóa',
    moreActions: 'Thao tác khác',
  },
  menu: {
    addProduct: 'Hàng hóa',
    addProductGroup: 'Nhóm hàng',
  },
  aria: {
    addSplit: 'Mở tùy chọn thêm mới',
    createVoucherSplit: 'Mở tùy chọn tạo giao dịch từ hàng đã chọn',
    bulkManageSplit: 'Mở tùy chọn xóa hàng đã chọn',
    columnPicker: 'Chọn cột hiển thị',
    selectAllPage: 'Chọn tất cả hàng trên trang này',
    selectRow: 'Chọn hàng',
    toggleStar: 'Đánh dấu sao',
    chonDonViTinh: 'Chọn đơn vị tính',
    /** Nút "+ Tạo mới" mở dialog tạo nhóm hàng inline. */
    quickCreateGroup: 'Tạo nhóm hàng mới',
    /** Icon sửa trên từng item cây nhóm hàng (sidebar). */
    editGroup: 'Sửa nhóm hàng',
    /** Nút "Chọn tất cả" trong footer section Nhóm hàng. */
    selectAllGroups: 'Chọn tất cả nhóm hàng',
    /** Nút "Bỏ chọn tất cả" trong footer section Nhóm hàng. */
    deselectAllGroups: 'Bỏ chọn tất cả nhóm hàng',
    /** Nút "Áp dụng" trong footer section Nhóm hàng. */
    applyGroups: 'Áp dụng bộ lọc nhóm hàng',
  },
  placeholders: {
    codeAuto: 'SP00000001',
    name: 'Bắt buộc',
    searchParentCategory: 'Tìm mã hoặc tên nhóm cha…',
    searchCodeName: 'Theo mã, tên hàng',
    /** Ô input "Nhóm hàng" trong sidebar Hàng hóa — click mở popup tree. */
    chonNhomHang: 'Chọn nhóm hàng',
    /** Summary trên ô input khi đã chọn nhiều nhóm — vd. "Đã chọn 3 nhóm". */
    selectedGroupsCount: 'Đã chọn {count} nhóm',
    searchByNoteDesc: 'Theo ghi chú, mô tả đặt hàng',
    searchByCode: 'Mã hàng',
    searchByName: 'Tên hàng',
    pickNhomHang: 'Chọn nhóm hàng (Bắt buộc)',
    pickNhaCungCap: 'Tìm mã hoặc tên nhà cung cấp…',
    pickThuongHieu: 'Chọn thương hiệu',
    pickViTri: 'Chọn một hoặc nhiều vị trí',
    pickDonViTinh: 'Tìm mã hoặc tên đơn vị tính…',
    maVach: 'Nhập mã vạch',
    maQR: 'Nhập mã QR',
    tenKhaiBaoVi: 'Tên khai báo tiếng Việt',
    tenKhaiBaoEn: 'Tên khai báo tiếng Anh',
    danhSachChiNhanhIds: 'VD: 1, 2, 3 (khi phạm vi = theo chi nhánh)',
    moTa: 'Nhập mô tả',
    note: 'Nhập ghi chú',
  },
  sections: {
    productCategories: {
      title: 'Nhóm sản phẩm',
      detailTitle: 'Chi tiết nhóm sản phẩm',
      description: 'Quản lý danh mục nhóm sản phẩm để chuẩn hóa phân loại hàng hóa.',
      viewBasic: 'Thông tin cơ bản',
      viewLinkage: 'Nhóm cha',
      viewStatus: 'Trạng thái',
      viewAudit: 'Hệ thống',
    },
    priceGroups: {
      title: 'Nhóm giá',
      detailTitle: 'Chi tiết nhóm giá',
      description: 'Quản lý nhóm giá áp dụng cho các loại sản phẩm hoặc nhóm khách hàng khác nhau.',
      viewBasic: 'Thông tin cơ bản',
      viewLinkage: 'Nhóm cha',
      viewStatus: 'Trạng thái',
      viewAudit: 'Hệ thống',
    },
    declarationGroups: {
      title: 'Nhóm công bố',
      detailTitle: 'Chi tiết nhóm công bố',
      description: 'Quản lý nhóm công bố phục vụ khai báo và chuẩn hóa hồ sơ sản phẩm.',
      viewBasic: 'Thông tin cơ bản',
      viewDeclaration: 'Thông tin công bố',
      viewLinkage: 'Nhóm cha',
      viewStatus: 'Trạng thái',
      viewAudit: 'Hệ thống',
    },
    products: {
      title: 'Hàng hóa',
      detailTitle: 'Chi tiết hàng hóa',
      description: 'Quản lý danh sách hàng hóa, nhóm hàng, giá và tồn kho.',
      viewBasic: 'Thông tin cơ bản',
      viewLinkage: 'Phân loại & liên kết',
      viewDeclarationAndFees: 'Công bố, phí & điều kiện',
      viewPricing: 'Giá & tồn',
      viewFlags: 'Thuộc tính',
      viewPricingFlags: 'Giá & tồn · Thuộc tính',
      viewCombo: 'Thành phần combo',
      viewNotes: 'Ghi chú',
      viewStatus: 'Trạng thái',
      viewAudit: 'Hệ thống',
      viewImage: 'Hình ảnh',
    },
  },
  badges: {
    hangCungLoai: 'Cùng loại',
    hangCungLoaiTooltip: 'Hàng cùng loại',
  },
  importMenu: {
    hangHoa: 'Hàng hóa',
    viTri: 'Vị trí hàng hóa',
    anh: 'Ảnh sản phẩm',
    thongTinVat: 'Thông tin VAT hàng hóa',
  },
  anhImport: {
    titles: {
      modal: 'Import ảnh sản phẩm',
      errors: 'Danh sách dòng lỗi',
    },
    actions: {
      open: 'Import ảnh',
      template: 'Tải file mẫu',
    },
    options: {
      question: 'Kiểu bố cục Excel (chọn trước khi chọn file)',
      doc: 'Ảnh hàng dọc — 2 cột (A: Mã SP, B: Ảnh)',
      ngang: 'Ảnh hàng ngang — A: Mã SP, ảnh từ cột B → …',
      url: 'Ảnh URL — A: Mã hàng, B: url1,url2… (tải về lưu hệ thống)',
    },
    hints: {
      doc: 'Mỗi dòng: mã SP + ảnh ở cột B (hoặc chèn ảnh trên dòng). Muốn nhiều ảnh cho 1 SP thì lặp mã trên nhiều dòng.',
      ngang: 'Mỗi dòng: mã SP ở cột A; các ảnh nằm ngang từ cột B, C, D… (mỗi ô một ảnh).',
      url: 'Mỗi dòng: mã hàng ở cột A; cột B chứa URL ảnh (http/https), nhiều URL cách nhau bằng dấu phẩy. Hệ thống tải ảnh về và lưu trữ nội bộ — không giữ URL khách.',
    },
    description: {
      doc: 'File XLSX 2 cột: A — Mã SP, B — Ảnh (chèn vào ô). Dữ liệu từ dòng 2. SP phải có sẵn; ảnh mới được thêm, ảnh cũ giữ nguyên (tối đa 10/SP).',
      ngang:
        'File XLSX: cột A — Mã SP; cột B trở đi — ảnh (mỗi ô một ảnh). Dữ liệu từ dòng 2. SP phải có sẵn; ảnh mới được thêm, ảnh cũ giữ nguyên (tối đa 10/SP).',
      url: 'File XLSX 2 cột: A — Mã hàng, B — URL ảnh (nhiều URL cách nhau bằng dấu phẩy). Dữ liệu từ dòng 2. Ảnh được tải từ URL khách rồi lưu về hệ thống; SP phải có sẵn (tối đa 10/SP).',
    },
    summary: '{rows} dòng · {images} ảnh · {products} sản phẩm',
    messages: {
      reading: 'Đang đọc file...',
      empty: 'File không có dữ liệu',
      noImages: 'Không tìm thấy ảnh nào trong file',
      noUrls: 'Không tìm thấy URL ảnh hợp lệ trong file',
      readFailed: 'Không đọc được file import',
      uploading: 'Đang upload ảnh {done}/{total}...',
      fetching: 'Đang tải & lưu ảnh {done}/{total}...',
      applying: 'Đang gắn ảnh vào sản phẩm...',
      success: 'Đã import {ok} ảnh cho {products} sản phẩm',
      partial: 'Đã import {ok} ảnh cho {products} sản phẩm (có cảnh báo)',
      failed: 'Import ảnh thất bại',
      missingImages: '{count} dòng không có ảnh — sẽ báo lỗi khi import.',
      missingUrls: '{count} dòng không có URL ảnh — sẽ báo lỗi khi import.',
    },
  },
  updateImport: {
    titles: {
      updateFromFile: 'Import hàng hóa',
      loiValidate: 'Danh sách dòng lỗi',
      xacNhanImport: 'Xác nhận nhập cập nhật',
      baoCaoKetQua: 'Báo cáo kết quả nhập cập nhật',
    },
    steps: {
      options: '1. Tuỳ chọn',
      validate: '2. Kiểm tra file',
      apply: '3. Áp dụng',
    },
    sections: {
      conflict: 'Xử lý trùng dữ liệu',
      scope: 'Phạm vi áp dụng',
      fields: 'Trường được phép cập nhật',
      file: 'File dữ liệu',
    },
    actions: {
      openButton: 'Import hàng hóa',
      taiFileMau: 'Tải về file mẫu',
      taiFileDuLieu: 'Tải file dữ liệu hiện tại',
      chonFile: 'Chọn file .xlsx',
      doiFile: 'Chọn file khác',
      taiFileLoi: 'Tải file lỗi',
      xacNhanImport: 'Xác nhận import',
      quayLai: 'Quay lại tuỳ chọn',
    },
    options: {
      xuLyTrungMa: {
        label: 'Trùng mã hàng nhưng khác tên?',
        baoLoi: 'Báo lỗi và dừng cả file',
        thayThe: 'Cập nhật theo tên trong file (khuyến nghị)',
      },
      xuLyMaVach: {
        label: 'Trùng mã vạch nhưng khác mã hàng?',
        baoLoi: 'Báo lỗi và dừng',
        thayTheMa: 'Thay mã hàng cũ bằng mã mới',
      },
      phamViGiaVon: {
        label: 'Áp dụng giá vốn trên',
      },
      phamViTrangThai: {
        label: 'Áp dụng trạng thái kinh doanh trên',
      },
      toanHeThong: 'Toàn mảng',
      theoChiNhanh: 'Theo chi nhánh',
      capNhatTonKho: { label: 'Cập nhật tồn kho' },
      capNhatMoTa: { label: 'Cập nhật mô tả' },
      capNhatGiaVon: { label: 'Cập nhật giá vốn' },
      capNhatDonViQuyDoi: {
        label: 'Cập nhật ĐVT quy đổi (1 hàng nhiều ĐVT)',
      },
    },
    placeholders: {
      chonChiNhanh: 'Chọn chi nhánh áp dụng',
      dropFile: 'Kéo thả file Excel vào đây, hoặc bấm chọn file',
      fileAccept: 'Chỉ nhận file .xlsx',
    },
    hints: {
      formatDescription:
        'Sử dụng file mẫu để cập nhật hàng hóa (trùng mã → cập nhật, mã mới → tạo mới).',
      dataFileDescription:
        'Tải file Excel chứa toàn bộ hàng hóa hiện tại → sửa các cột cần thiết → chọn lại file để kiểm tra và import.',
      donViQuyDoiDescription:
        'Đọc sheet «ĐVT quy đổi». ĐVT cơ bản (tỷ lệ 1) tự thêm nếu thiếu. Chỉ áp dụng hàng vật lý, không áp dụng combo.',
    },
    messages: {
      validateFailed: 'Có {loi} dòng lỗi trên tổng {tong} dòng — chưa import',
      validateSuccess: 'Sẽ cập nhật {capNhat} dòng và tạo mới {taoMoi} dòng',
      applySuccess: 'Đã xử lý {thanhCong} dòng thành công, {thatBai} dòng thất bại',
      applyFailed: 'Nhập cập nhật thất bại, vui lòng thử lại',
      fileSelected: 'Đã chọn: {name}',
      chonChiNhanhBatBuoc: 'Chọn ít nhất một chi nhánh khi phạm vi là Theo chi nhánh',
      soDongSanSang: '{count} dòng sẵn sàng import',
      dangKiemTra: 'Đang kiểm tra {count} dòng…',
    },
    report: {
      dong: 'Dòng',
      maHang: 'Mã hàng',
      tenHang: 'Tên hàng',
      hanhDong: 'Hành động',
      capNhat: 'Cập nhật',
      taoMoi: 'Tạo mới',
      chiTietLoi: 'Chi tiết lỗi',
      truongThayDoi: 'Trường thay đổi',
      soDonVi: 'Số ĐVT',
      tongDong: 'Tổng dòng',
      soLoi: 'Số lỗi',
      soCapNhat: 'Cập nhật',
      soTaoMoi: 'Tạo mới',
      thanhCong: 'Thành công',
      thatBai: 'Thất bại',
    },
  },
  viTriImport: {
    titles: {
      modal: 'Import vị trí',
      loiValidate: 'Danh sách dòng lỗi',
    },
    sections: {
      options: 'Tuỳ chọn import',
    },
    actions: {
      openButton: 'Import vị trí',
      taiFileMau: 'Tải về file mẫu',
    },
    options: {
      taoMoiLabel: 'Khi mã vị trí chưa có trong chi nhánh hiện tại?',
      taoMoi: 'Tạo mới vị trí (mã A–Z/0–9 giữ nguyên; tên/ký tự đặc biệt → tự sinh VT0001…)',
      khongTaoMoi: 'Không tạo mới — báo lỗi nếu thiếu mã vị trí',
    },
    hints: {
      description:
        'File Excel gồm 2 cột: Mã sản phẩm, Mã vị trí. Một sản phẩm nhiều vị trí → nhiều dòng cùng mã sản phẩm (hệ thống tự nhóm khi chọn file).',
      chiNhanhNote: 'Vị trí luôn được gắn cho chi nhánh đang đứng.',
    },
    messages: {
      empty: 'File không có dữ liệu hợp lệ',
      failed: 'Import vị trí thất bại',
      success: 'Đã gắn vị trí cho {thanhCong} sản phẩm (tạo mới {taoMoi} vị trí)',
      soDongSanSang: '{flat} dòng Excel → {count} sản phẩm sẵn sàng import',
    },
  },
}
